function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState } from 'vuex';
import { firebaseConfig, GA_EVENTS } from '@/js/constants';
import StateComponent from '@/components/StateComponent.vue';
export default {
  components: {
    StateComponent: StateComponent
  },
  props: {
    videos: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    modulevid: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      flagVideo: true,
      actualVideo: []
    };
  },
  created: function created() {
    console.log("module:", this.modulevid);
  },
  computed: _objectSpread(_objectSpread({}, mapState('data-platform', ['inca_base_url'])), mapState('data-platform', ['companyCode', 'companyName'])),
  methods: {
    has_videos: function has_videos() {
      var _this = this;
      if (this.videos && this.videos.filter(function (x) {
        return x.module == _this.modulevid;
      }).length == 0) {
        return true;
      }
      return false;
    },
    getImage: function getImage(item) {
      console.log(item);
      var aux = "@/assets/video_data_platform.png";
      return aux;
      /*
      if (url.length<73){
        let conSubstr = url.substr(30, 11);
        let img= "http://img.youtube.com/vi/"+ conSubstr + "/0.jpg"
        console.log(img)
        return img
      }
      else{
        let conSubstr = url.substr(32, 33);
        let img= "https://lh3.googleusercontent.com/d/" + conSubstr
        console.log(img)
        return img
      }
      */
    },
    openYoutube: function openYoutube(item) {
      console.log('item:', item);
      this.actualVideo = item;
      this.flagVideo = false;
      if (this.$gtm.enabled() && window.dataLayer) {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: GA_EVENTS.VIEW_VIDEO_HC,
          id_video: item.video_id,
          company_code: this.companyCode,
          hash_email: this.stringToHash(userInfo.email),
          'module': item.module
        });
      }
    },
    shareVideo: function shareVideo() {
      var URLdomain = window.location.host;
      console.log("base_url: ", URLdomain);
      console.log('copy:', this.actualVideo);
      //console.log("base_url: ", this.inca_base_url)
      //this.$router.push({ name: 'ViewVideo', params: { video_id: this.actualVideo.video_id} })
      var url = URLdomain + '/#/video/' + this.actualVideo.video_id;
      navigator.clipboard.writeText(url);
    },
    openRelation: function openRelation() {
      this.$router.push({
        name: 'ViewVideo',
        params: {
          video_id: this.actualVideo.video_id
        }
      });
    }
  }
};